import type { ApiError } from '@asetquhub/validation';

export class ApiErrorResponse extends Error {
  public readonly errors: ApiError[];
  public readonly status: number;
  public readonly statusText: string;
  public readonly requestId?: string;

  constructor(errors: ApiError[], status: number, statusText: string, requestId?: string) {
    const apiMessage = errors.length > 0 ? errors[0]?.message : 'An error occurred';
    // Append requestId to the message so toast.error(error.message) shows it automatically.
    const message = requestId ? `${apiMessage} · ID: ${requestId}` : apiMessage;
    super(message);

    this.name = 'ApiErrorResponse';
    this.errors = errors;
    this.status = status;
    this.statusText = statusText;
    this.requestId = requestId;
  }

  // Helper method to get the first error message
  get firstError(): ApiError | undefined {
    return this.errors[0];
  }

  // Helper method to check if there are validation errors
  get hasValidationErrors(): boolean {
    return this.errors.some(error => error.type === 'validation');
  }

  // Helper method to check if there are business errors
  get hasBusinessErrors(): boolean {
    return this.errors.some(error => error.type === 'business');
  }

  // Helper method to get errors by type
  getErrorsByType(type: ApiError['type']): ApiError[] {
    return this.errors.filter(error => error.type === type);
  }

  // Helper method to get errors by field
  getErrorsByField(field: string): ApiError[] {
    return this.errors.filter(error => error.field === field);
  }
}

export type ApiErrorType = ApiErrorResponse;
